var _style, _g, _g2, _defs, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeleniumDeficiency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1C8078;}\n\t.st1{fill:#FEE0B4;}\n\t.st2{fill:#EE744B;}\n\t.st3{opacity:0;clip-path:url(#SVGID_2_);fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.7,180.3c42.8,0,77.6-34.4,77.6-76.9c0-42.4-34.7-76.9-77.6-76.9S28.2,61,28.2,103.4 C28.2,145.8,62.9,180.3,105.7,180.3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.8,60.7c-1-0.5-2.1-0.9-3.3-1.1c7.7,9.8,10.1,31.4-4.2,58.7c-10.1,19.3-26.6,27.6-38.8,26.1 c0.8,0.6,1.6,1.2,2.6,1.7c11.9,6.2,32.6-1,44.5-23.6C140.5,90.5,133.9,66.5,122.8,60.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115.4,118.3c14.3-27.3,12-48.9,4.2-58.7c-5.8-1-12.7,2.6-18.1,13c-6.5,12.5-19.3,36.8-26.5,50.7 c-3.9,7.5-4.4,16.1,1.7,21.1C88.8,146,105.2,137.7,115.4,118.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M119.6,59.6c-5.8-1-12.7,2.6-18.1,13c-0.1,0.2-0.2,0.3-0.2,0.5c3.1-1.3,6.8-6.3,8.1-6.5 c1.6-0.3-0.4,5.6,2.5,8.2c3,2.6,9,0.7,9.9,1.2c0.9,0.4,0.6,5,2.5,5.6c0.6,0.2,1.1,0.3,1.6,0.4C125.9,72.2,123.4,64.5,119.6,59.6z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M129,84.2c1.2,1.5,3.2,4.9,4.6,7.4c1.5-16-3.7-27.1-10.8-30.8c-1-0.5-2.1-0.9-3.3-1.1 c3.8,4.8,6.3,12.5,6.2,22.4C126.7,82.2,127.6,82.5,129,84.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M110.2,131c-2.1-0.8,5.5-9.8,6.1-14.5c0-0.1,0-0.2,0-0.3c-0.3,0.7-0.7,1.4-1,2c-8.3,15.8-20.8,24.3-31.8,26 c-0.7,1-1.3,2.1-1.8,3c9.1,3,21.8-0.5,32.3-11.3C113.7,133.6,111.6,131.5,110.2,131z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M115.4,118.3c0.4-0.7,0.7-1.4,1-2c0.4-4.1-5.9,3.8-8.3,7.8c-2.5,4.1-6.4,4.6-9.4,4.1c-3-0.5-4.6,3.3-5,5.4 c-0.4,2.1-4.2,6-7,7.4c-1,0.5-2.1,1.8-3.1,3.2C94.6,142.6,107.1,134.2,115.4,118.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M80.5,112.6c0.5,0.3,1.2,0.5,2-0.1c2.2-1.4,2.9-3.9,4.4-5.6c1.5-1.7,5.2,0.5,7.2-4.5c2-5.1,0.8-7.8-0.7-8.5 c-0.6-0.2-1.6-0.7-2.6-1.3C87.5,99.3,83.8,106.3,80.5,112.6z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M105.7,180.3c42.8,0,77.6-34.4,77.6-76.9c0-42.4-34.7-76.9-77.6-76.9S28.2,61,28.2,103.4 C28.2,145.8,62.9,180.3,105.7,180.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "28.2,107.7 183.3,107.7 192.6,154.3 151.7,191.3 105.7,200.6 22.8,190.3 22.8,124.4  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeleniumDeficiency);
export default __webpack_public_path__ + "static/media/Selenium_Deficiency.a15320e41e870c475817847b30d3fddd.svg";
export { ForwardRef as ReactComponent };